import { MultiViewController } from "./multi-view-controller.js";
import { styles } from "./multi-view-controller.styles.js";
import { template } from "./multi-view-controller.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fluent-multi-view-controller>
 */
export const definition = MultiViewController.compose({
    name: `${DesignSystem.prefix}-multi-view-controller`,
    template,
    styles
});
//# sourceMappingURL=multi-view-controller.definition.js.map